// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-router-dom components
import { Link as RouterLink } from "react-router-dom";

// @mui material components
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Vision UI Dashboard PRO React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// Vision UI Dashboard PRO React base styles
import typography from "assets/theme/base/typography";
import { Grid } from "@mui/material";

function Header({ links }) {
  const { size } = typography;

  const renderLinks = () =>
    links.map((link) => (
      <VuiBox key={link.name} component="li" lineHeight={1}
        sx={({ breakpoints }) => ({
          px: '16px',
            [breakpoints.down("sm")]: {
              px: '7px',
            },
          })}
      >
        {link.isInternal ? (
          <RouterLink to={link.href} style={{ textDecoration: 'none' }}>
            <VuiTypography variant="button" fontWeight="medium" color="text" fontSize="16px">
              {link.name}
            </VuiTypography>
          </RouterLink>
        ) : (
          <Link href={link.href} target="_blank">
            <VuiTypography variant="button" fontWeight="medium" color="text" fontSize="16px">
              {link.name}
            </VuiTypography>
          </Link>
        )}
      </VuiBox>
    ));

  return (
    <Grid
      sx={({ breakpoints, functions: { pxToRem } }) => ({
        backgroundColor: '#ffffff',
        py: '34px',
        [breakpoints.down("md")]: {
          py: '10px',
        },
      })}
    >        
        <VuiBox
          sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
            pt: 0,
            px: '20px',
            position: "relative",
            [breakpoints.up("xl")]: {
    //          marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
              marginLeft: 0,
              // pl:30,
              // pr:30,
              maxWidth: '1390px',
              mx: 'auto',
              px: '15px',
              transition: transitions.create(["margin-left", "margin-right"], {
                easing: transitions.easing.easeInOut,
                duration: transitions.duration.standard,
              }),
            },
            [breakpoints.up("lg")]: {
              // pl:20,
              // pr:20
              maxWidth: '1230px',
              mx: 'auto',
              px: '20px',
            },
            [breakpoints.up("sm")]: {
              // pl:5,
              // pr:5
              maxWidth: '800px',
              mx: 'auto',
              px: '20px',
            },
          })}
        >
          <Grid container spacing={2}  sx={{alignItems: 'center'}}>
            <Grid item xs={12} md={5}>
              <VuiBox
                sx={({ breakpoints }) => ({
                  lineHeight: '0',
                  textAlign: 'center',
                  [breakpoints.up("md")]: {
                    textAlign: 'left',
                  },
                })}>
                <Link href={'https://www.superprocure.com/'}><img src="https://www.superprocure.com/wp-content/uploads/2022/08/Logo_-01.png" alt="SuperProcure" width={210} /></Link>
              </VuiBox>
            </Grid>
            <Grid item xs={12} md={7} 
              sx={({ breakpoints }) => ({
                [breakpoints.down("md")]: {
                  pt: '5px !important',
                },
              })}
            >
              <VuiBox
                component="ul"
                sx={({ breakpoints }) => ({
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "center",
                  listStyle: "none",
                  mt: .5,
                  mb: 0,
                  p: 0,
                  [breakpoints.up("md")]: {
                    mt: 0,
                    justifyContent: 'flex-end'
                  },
                })}
              >
                {renderLinks()}
              </VuiBox>  
            </Grid>
          </Grid>
        </VuiBox>
    </Grid>
    
  );
}

// Setting default values for the props of Header
Header.defaultProps = {
  links: [
    { href: "/", name: "Home", isInternal: true },
    // { href: "/verify-vahan", name: "Verify Trucks", isInternal: true },
    // { href: "/verify-sarathi", name: "Verify Drivers", isInternal: true },
    // { href: "/track-fastag", name: "Track Fastag", isInternal: true },
    { href: "https://www.superprocure.com/about-us/", name: "About us" },
    { href: "https://www.superprocure.com/blog", name: "Blog" },
    { href: "https://www.superprocure.com/case-studies", name: "Case studies" },
  ],
};

// Typechecking props for the Header
Header.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.object),
};

export default Header;
